(function(){
    angular
        .module('app')
        .directive('compilador', compiladorDirective);

    compiladorDirective.$inject = ['$compile']
     function compiladorDirective($compile){
	 // directive factory creates a link function
	 return {
	 scope:{'pagesimple':'=','control':'='},
	  link:function(scope, element, attrs) {
	   scope.$watch("pagesimple",
	     function(value) {
	     	//console.log(attrs.controller);
	     	scope.controller = attrs.controller;
	     	//console.log(scope);

	       // when the 'compile' expression changes
	       // assign it into the current DOM
	       element.html("<div class='panel' >"+value+"</div>");
	       // compile the new donM and link it to the current
	       // scope.
	       // NOTE: we only compile .childNodes so that
	       // we don't get into infinite loop compiling ourselves
	       $compile(element.contents())(scope);
	     }
	   );
	 }
	}

	}
})();